import { BrowseArtefactsModalContent } from '@modules/bookmark/components/BrowseArtefactsModalContent';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { trackWisdomEvents } from '@modules/oracle/utils';
import { ArrowForwardRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { ArtefactEditableByFilter, ArtefactType } from 'generated/graphql';
import { useCallback } from 'react';

export const WisdomSeeAllChatsButton = () => {
  const { openModal } = useMuiModalContext();

  const openBrowseArtefactsModal = useCallback(() => {
    openModal({
      contentComponent: () => (
        <BrowseArtefactsModalContent
          artefactTypes={[
            {
              type: ArtefactType.Chat,
            },
          ]}
          editableBy={ArtefactEditableByFilter.User}
        />
      ),
      modalProps: {
        fullWidth: true,
        maxWidth: 'lg',
        PaperProps: {
          elevation: 0,
          sx: { width: '1000px', height: '600px', borderRadius: 2 },
        },
      },
    });

    trackWisdomEvents({
      eventName: 'Wisdom - See All Chats Button Clicked',
    });
  }, [openModal]);

  return (
    <Button
      variant="text"
      onClick={openBrowseArtefactsModal}
      fullWidth
      sx={{
        justifyContent: 'space-between',
      }}
      endIcon={<ArrowForwardRounded />}
    >
      See all Chats
    </Button>
  );
};
